import {
	Grid,
	GridColumn,
	useSnackbar
} from "@walmart-web/livingdesign-components";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { getService, getServiceWithResponseType } from "../../../axios/axios";
import { EXTERNAL_USER_SERVICE } from "../../../constants/baseURLs";
import {
	ACTIONS,
	ADD_NEW_RATE,
	APPROVED_RATE, APPROVING_ATTORNEY, CURRENT_STANDARD_RATE, DISCOUNT, END_DATE, JUSTIFICATION_FOR_RATE,
	PAR_EDIT,
	PAR_EXPORT_SUCCESS_MSG,
	PRACTICE_AREA,
	PROPOSED_WALMART_RATE, REACH_TO_OCM, REJECTION_COMMENT, REJECTION_REASON, REQUESTER_EMAIL, START_DATE,
	STATUS_ACTIVE,
	USER_STATUS_LABELS,
	SYS_ADMIN,
	OC_ADMIN
} from "../../../constants/constants";
import { getErrorMessage, getRejectionReason } from "../../../helpers/utils";
import { isCurrencyValueEmptyCheck, isValueEmptyCheck } from "../../../helpers/validationUtils";
import { setPracticeAreaRates } from "../../../store/actions/peopleAction";
import PracticeAreaRatesStyles from "./PeoplePracticeAreaRatesList.styles";
import { displayLocalDate } from "../../../helpers/utcUtils";
import MuiDataTable from "../../../components/Table/MuiDataTable/MuiDataTable";
import ActionPopover from "../../../components/Table/ActionPopover/ActionPopover";
import { TableCell, TableRow, Tooltip } from "@mui/material";
import { formSearchQuery, getExportedData } from "../../../helpers/tableUtils";
import { Operations } from "../../../axios/operations";
import RateRequestStatus from "../Utils/RateRequestStatus";
import { UPDATE } from "../../../constants/actionButtons";
import EditRateModal from "../../../components/Modal/EditRateModal/EditRateModal";
import InactivateRateModal from "../../../components/Modal/InactivateRateModal/InactivateRateModal";
import ViewMatterPARateDetail from "../PeopleRates/ViewMatterPARateDetails";
import { amountFormat, getCurrencyAmount } from "../../../helpers/commonUtils";

/*
* This component is for displaying PRACTICE AREA Rates associated with any user
*/

const PeoplePracticeAreaRatesList = (props) => {
	const accessibility = useSelector((state) => state?.accessibility?.applicationAccess?.organization?.tabs?.people?.tabs?.active?.details?.tabs?.practiceAreaRates);
	const status = useSelector(state => state?.people?.userDetail?.status);
	const classes = PracticeAreaRatesStyles();
	const userRequestId = useSelector((state) => state?.user?.userRequestId);
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const { addSnack } = useSnackbar();
  	const { peopleId } = useParams()
	const { practiceAreaRates } = useSelector((state) => state?.people);
	const { userDetail } = useSelector((state) => state?.people)
	const masterDetails = useSelector(state => state?.masterData?.masterDatas);
	const practiceAreas = useSelector((state) => state?.matter?.practiceAreas);
 	const { identifier } = useSelector((state) => state?.organization?.organizationDetailValues);
	const practiceAreaCodeToName = useSelector(state => state?.matter?.practiceAreaCodeToName);
	const [tableRowIndex, setTableRowIndex] = useState([]);
	const [filters, setFilters] = useState("");
	const [rateColumns, setRateColumns] = useState([]);
	const [editRateOpen, setEditRateOpen] = useState(false);
	const [editRateId, setEditRateId] = useState(null);
	const [exportLoading, setExportLoading] = useState(false);
	const [inactivateModalOpen, setInactivateModalOpen] = useState(false);
	const [inactivateRateId, setInactivateRateId] = useState(null);
	const [inactivateWarningMessage, setInactivateWarningMessage] = useState("");
	const practiceAreasDropDown = [...new Set(practiceAreas?.map(val => val?.name))];
	const {userDetail: currentUserDetail} = useSelector((state) => state?.user);
	const userRoles = currentUserDetail?.roleCode || [];
	const isOCOrADMIN = userRoles?.includes(SYS_ADMIN) || userRoles?.includes(OC_ADMIN);
	
	
	useEffect(() => {
		COLUMNS.map((col)=>{col.options.setCellHeaderProps = () => ({
			style: { fontWeight: "bold", color: "black" }, 
		})})
		setRateColumns(COLUMNS);
		getPracticeAreaRates();
	}, [filters, userRequestId]);

	useEffect(() => {
		return () => {
			dispatch(setPracticeAreaRates([]));
		}
	}, [])

	/*
	*Function to call User Request Service to fetch PRACTICE AREA Rates
	*/
	const getPracticeAreaRates = () => {
		setLoading(true);
		const csv = "csv=false";
		getService(EXTERNAL_USER_SERVICE, `/search/practice-area-specific-rates/v1?filter=(${defaultFilterCondition}${filters})&${csv}`)
		.then((res) => {
			dispatch(setPracticeAreaRates(res?.data?.practiceAreaSpecificRates));
			setLoading(false);
		}).catch((error) => {
			addSnack({
			message: getErrorMessage(error)
		});
			setLoading(false);
		});
	}

	const renderApprovedRate=(value, tableMeta) => {
		return ( tableMeta?.rowData?.[4] === "Active" ? getCurrencyAmount(amountFormat(value)) : '-' )
	}

	const renderStatus = (value, tableMeta) => {
		return <RateRequestStatus detail={{status: value}} />

	}

	const actionItems = [
	{
		"actionId": 0,
		"label": "Inactivate",
		"isAboveDivider": true,
		"isDisabled": !isOCOrADMIN,
		"showAction": isOCOrADMIN
	}];

	const onClickOption = (selectedId, tableMeta) => {
		switch (selectedId) {
			case 0:
				const rateData = practiceAreaRates?.find(rate => rate.id === tableMeta.rowData[15]);
				setInactivateRateId(tableMeta.rowData[15]);
				checkIfOnlyActiveRate(rateData);
				break;
			default:
			  return null;
		}
	}

	const renderPracticeArea = (value, tableMeta) => {
		return isValueEmptyCheck(practiceAreaCodeToName?.hasOwnProperty(value) && practiceAreaCodeToName[value])
	}

	const FILTER_CONFIGS = [
	{
		colKey: "status",
		type: "checkbox",
		label: "Status",
		options: [
			"Active",
			"Expired",
			"Inactive",
			"Invalid",
			"Rejected",
			"Submitted",
		],
		defaultOpen: true,
		displayLabel: false,
		accordian: 'Status',
	},
	{
		name:  "practiceAreaCode",
		colKey: "practiceAreaCode",
		type: "autocompleteMultiSelect",
		label: "Practice Area",
		defaultOpen: true,
		displayLabel: false,
		options: (practiceAreasDropDown ?? []),
		accordian: 'Practice Area',
	},
	{
		name: "currentWalmartRate",
		colKey: "currentWalmartRate",
		type: "textField",
		defaultOpen: true,
		displayLabel: false,
		accordian: 'Approved Rate',
	}
	];
	
	const defaultFilterCondition = `${formSearchQuery(
		"isActive",
		Operations.EQ,
		true,
		'boolean'
	)}+${
	formSearchQuery(
		"userRequestId",
		Operations.EQ,
		userRequestId,
		'id'
	)}`;

	const handleExport = () => {
		setExportLoading(true);
		const csv = "csv=true";
		getServiceWithResponseType(EXTERNAL_USER_SERVICE, `/search/practice-area-specific-rates/v1?filter=(${defaultFilterCondition})&${csv}`, "arraybuffer")
		.then((response) => {
			const data = response?.data;
			const contentType = response?.headers?.["content-type"];
			getExportedData(data, contentType,'practice-area-specific-rates');
			addSnack({ message: PAR_EXPORT_SUCCESS_MSG });
		})
		.catch((error) => {
			addSnack({ message: getErrorMessage(error) });
		})
		.finally(() => {
			setExportLoading(false);
		});
	}

	const COLUMNS = [
		{
			name: "currentWalmartRate",
			label: APPROVED_RATE,
			colKey: "currentWalmartRate",
			options: {
				sort: false,
				filter: true,
				customBodyRender: renderApprovedRate,
				customFilterListOptions: { render: (v) => `Approved Rate: ${getCurrencyAmount(amountFormat(parseInt((v))))}` },
				filterOptions: {
					logic: (value, filters) => {
					if (!filters[0]) return false;
					return value !== getCurrencyAmount(amountFormat(parseInt((filters[0]))));
					},
				},
			},
		},
		{
			name: "practiceAreaCode",
			label: PRACTICE_AREA,
			colKey: "practiceAreaCode",
			options: {
				sort: false,
				display: true,
				customBodyRender: renderPracticeArea,
				customFilterListOptions: { render: (v) => `Practice Area: ${v}` },

			},
		},
		{
			name: "startDate",
			label: START_DATE,
			colKey: "startDate",
			options: {
				sort: false,
				display: true,
				customBodyRender: (value) => (
					<Tooltip title={REACH_TO_OCM} placement="top">
						<span>{value ? displayLocalDate(value) : "-"} </span>
					</Tooltip>
				)
			},
		},
		{
			name: "endDate",
			label: END_DATE,
			colKey: "endDate",
			options: {
				sort: false,
				display: true,
				customBodyRender: (value) => (value ? displayLocalDate(value) : "-")
			},
		},
		{
			name: "status",
			label: "Status",
			colKey: "status",
			options: {
				sort: false,
				customBodyRender: renderStatus,
				customFilterListOptions: { render: (v) => `Status: ${v}` },
			},
		},
		{
			name: "actions",
			label: ACTIONS,
			colKey: "actions",
			options: {
				sort: false,
				customBodyRender: (value, tableMeta) => {
					return (
						<ActionPopover
							actionItems={tableMeta?.rowData?.[4] === "Active" ? actionItems : []}
							onClickOption={onClickOption}
							data-testid="action-btn"
							tableMeta={tableMeta}
						/>
					)
				},
			},
		},
		{
			name: "currentStandardRate",
			colKey: "currentStandardRate",
			options: {
				display: false
			},
		},	
		{
			name: "proposedWalmartRate",
			colKey: "proposedWalmartRate",
			options: {
				display: false
			},
		},	
		{
			name: "discount",
			colKey: "discount",
			options: {
				display: false
			},
		},
		{
			name: "walmartApprovingAttorneyFullName",
			colKey: "walmartApprovingAttorneyFullName",
			options: {
				display: false
			},
		},
		{
			name: "requesterEmailId",
			colKey: "requesterEmailId",
			options: {
				display: false
			},
		},
		{
			name: "outsideOrgJustification",
			colKey: "outsideOrgJustification",
			options: {
				display: false
			},
		},
		{
			name: "rejectReasonCategoryCode",
			colKey: "rejectReasonCategoryCode",
			options: {
				display: false
			},
		},
		{
			name: "rejectReasonDetails",
			colKey: "rejectReasonDetails",
		 options: {
				display: false
			},
		},
		{
			name: "matterName",
			colKey: "matterName",
			options: {
				display: false
			},
		},
		{
			name: "id",
			colKey: "id",
			options: {
				display: false
			},
		},
		{
			name: "walmartApprovingAttorneyUserId",
			colKey: "walmartApprovingAttorneyUserId",
			options: {
				display: false
			},
		},
	];

	const handleServerSideFilter = (filterQuery) => {
		setFilters(filterQuery);
	};

	const customOptions = {
		expandableRows: true,
		expandableRowsHeader: false,
		expandableRowsOnClick: true,
		isRowExpandable: (tableRowIndex, expandedRows) => {
		  return true;
		},
		rowsExpanded: tableRowIndex,
		renderExpandableRow: (rowData, rowMeta, updateValue) => {
		  return (
			<ViewMatterPARateDetail rowData={rowData} fromMatterSpecificRates={false} />
		  );
		},
		onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) => {},
		serverSide: false,
		onServerSideFilter: handleServerSideFilter,
		filterConfigs: FILTER_CONFIGS,
		totalCount: practiceAreaRates?.count ?? 0,
		persistFilter: true,
		filterComponentName: "PAR",
		isRate: true	  
	};

	/**
 * Function will use for add New Rate
 */
	const addNewRate = () => {
		history.push(`/people/${userDetail?.userRequestId}/add-practice-area-rate`, {peopleIdentifier: peopleId, organizationName: userDetail?.organizationName, userName:`${userDetail?.firstName} ${userDetail?.lastName}`, selectedTab:2})
	}

	const checkIfOnlyActiveRate = (rateData) => {
		try {
			const activeRatesForPracticeArea = practiceAreaRates?.filter(rate => 
				rate.status === "Active" && 
				rate.practiceAreaCode === rateData?.practiceAreaCode
			) || [];
			
			const activeRatesCount = activeRatesForPracticeArea.length;
			
			const baseMessage = "Are you sure you want to inactivate this practice area rate?";
			
			if (activeRatesCount === 1) {
				const practiceAreaName = practiceAreaCodeToName[rateData?.practiceAreaCode] || rateData?.practiceAreaCode;
				setInactivateWarningMessage(`${baseMessage}\n\nWarning: This is the only active rate for ${practiceAreaName}. Inactivating this rate will leave no active rates for this practice area.`);
			} else {
				setInactivateWarningMessage(baseMessage);
			}
			
			setInactivateModalOpen(true);
		} catch (error) {
			console.error("Error checking active rates:", error);
			setInactivateWarningMessage("Are you sure you want to inactivate this practice area rate?");
			setInactivateModalOpen(true);
		}
	};

	return (
		<div data-testid="specific-rates-practice-container">
			<div className={classes.whiteContainer}>
				<MuiDataTable
					data={practiceAreaRates}
					columns={rateColumns}
					setTableColumns={setRateColumns}
					groupFilter={true}
					disableSearch={true}
					exportLoading={exportLoading}
					onExportClick={handleExport}
					customOptions={customOptions}
					loading={loading}
					hideAddNewButton={!(accessibility?.addNew && status?.toLowerCase() === STATUS_ACTIVE)}
					addNewLabel={ADD_NEW_RATE}
					onAddNew={addNewRate}
					disableAddNew={status === USER_STATUS_LABELS.INACTIVE}
				/>	
				<EditRateModal
					open={editRateOpen}
					setOpen={setEditRateOpen}
					title={PAR_EDIT}
					editButtonText={UPDATE}
					fromMatterSpecificRates={false}
					editRateValues={practiceAreaRates?.filter((item)=>item.id === editRateId)[0]}
					getRates={getPracticeAreaRates}
				/>
				<InactivateRateModal
					open={inactivateModalOpen}
					setOpen={setInactivateModalOpen}
					rateId={inactivateRateId}
					rateType="practice-area"
					warningMessage={inactivateWarningMessage}
					onSuccess={getPracticeAreaRates}
				/>
			</div>
		</div>
	)
}

export default PeoplePracticeAreaRatesList;
